module.exports = __webpack_public_path__ + "static/media/billing.461203d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/billing.svg
// module id = 1164
// module chunks = 0